var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist';
import { CaseTag } from '@debbie/common/dist/cases';
import { c, h } from '@debbie/cortex/dist';
import * as casesLib from '@debbie/cortex/dist/api/cases';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { Badge, EditSelection } from '../';
import THEME from '../../theme';
import { Col } from '../Grid';
import TagsEditor from '../TagsEditor';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups';
const Header = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    if (!singleCase)
        return null;
    const updateCaseGroup = (id) => __awaiter(void 0, void 0, void 0, function* () {
        singleCase &&
            (yield casesLib.patch(singleCase.caseId, {
                caseGroupId: id,
            }));
        yield c.cases.getById(props.caseId);
    });
    return (React.createElement(Col, { width: "12" },
        React.createElement("h3", null,
            React.createElement("small", { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.cases.createdAt }, moment(singleCase.createdAt).format(THEME.DATE_FORMAT_LONG)),
            singleCase.caseGroup && (React.createElement(Badge, { style: {
                    fontSize: '0.6em',
                    marginLeft: '10px',
                }, theme: THEME.COLOR_GREY }, singleCase.caseGroup.label)),
            site === Site.Caseworker && (React.createElement("span", { "data-tooltip-content": singleCase.caseGroup
                    ? lang.caseGroups.editCaseGroup
                    : lang.caseGroups.addCaseGroup, "data-tooltip-id": "tooltip-left" },
                React.createElement(EditSelection, { onUpdate: updateCaseGroup, placeholder: lang.caseGroups.caseGroups, style: { marginTop: '0.5em' }, list: caseGroups
                        ? caseGroups.map((caseGroup) => ({
                            returnData: caseGroup.id,
                            heading: caseGroup.label,
                            key: caseGroup.id,
                        }))
                        : [], value: (_a = singleCase.caseGroup) === null || _a === void 0 ? void 0 : _a.id }))),
            !!singleCase.tags.length && (React.createElement("div", { style: { float: 'right' } },
                React.createElement(TagsEditor, { tags: singleCase.tags, onChange: (tags) => __awaiter(void 0, void 0, void 0, function* () {
                        yield casesLib.patch(singleCase.caseId, {
                            tags,
                        });
                        yield c.cases.getById(props.caseId);
                    }), availableTags: [CaseTag.SURVEILLANCE], translations: lang.caseTags }))))));
};
export default Header;
//# sourceMappingURL=Header.js.map